import { html } from 'uhtml';

class FaqListItem {
  constructor(element, context) {
    this.element = element;
    const _this = this;
    context.counterIndex += 1;
    const answerId = `faq-answer-${context.counterIndex}`;

    const button = html.node`
      <button class="faq__toggle visually-hidden focusable"
              aria-controls="${answerId}"
              onclick=${() => _this.toggle()}>
        <span class="collapsed-only">Show answer</span>
        <span class="expanded-only">Hide answer</span>
      </button>
    `;

    element.insertBefore(button, null);

    element.setAttribute(
      'aria-expanded',
      element.classList.contains('faq--sticky'),
    );
    element
      .querySelector(':scope > .faq__question')
      .addEventListener('click', () => _this.toggle());

    element.querySelector(':scope > .faq__answer').setAttribute('id', answerId);

    if (`#${element.id}` === window.location.hash) {
      this.open(false);
    }
  }

  isOpen() {
    return this.element.getAttribute('aria-expanded') === 'true';
  }

  open(focus) {
    this.element.setAttribute('aria-expanded', 'true');

    if (focus !== false) {
      const answer = this.element.querySelector(':scope > .faq__answer');
      answer.setAttribute('tabindex', -1);
      answer.focus();
    }
  }

  close() {
    this.element.setAttribute('aria-expanded', 'false');
  }

  toggle(focus) {
    return this.isOpen() ? this.close() : this.open(focus);
  }
}

export default FaqListItem;
